module.exports = __webpack_public_path__ + "img/menu_outline.577ab134.svg";